import RepresentativeSelect from './RepresentativeSelect'

export default RepresentativeSelect
